<template>
  <div class="w-100 d-flex justify-content-center">
    <div class="swipe-up-container d-flex justify-content-center">
      <div class="swipe-up" id="swipe-up">
        <div class="font-general-r d-flex justify-space-between aling-items-center text-white">
          <div class="ml-3">
            <v-bottom-sheet
              v-model="sheet"
              :hide-overlay="true"
              class="bottom-sheet"
              :scrollable="true"
              inset
              max-width="90%"
            >

              <template v-slot:activator="{ on, attrs }">
                <div
                  class="swipe-text"
                  v-bind="attrs"
                  v-on="on"
                  @click="!sheet"
                >
                  {{ sheet ? 'CERRAR' : 'VER CARRITO' }}
                </div>
              </template>

              <v-sheet
                class="text-center"
                height="650px"
                color="accent"
              >

                <v-card class="card-cart mt-0 elevation-0" color="accent">
                  <v-card-text style="height: 600px;">
                    <div class="ml-15 mb-5">
                      <v-badge
                        left
                        :content="`${cart.cart_products.length}`"
                        color="accent"
                        offset-x="10"
                        offset-y="10"
                        class="badge-bolsa"
                      >
                        <img
                          class="cart-image-bolsa"
                          src="@/assets/store/iconos/bolsa.svg"
                        >
                      </v-badge>
                    </div>

                    <div v-if="cart.cart_products.length">

                      <div v-if="campaign_order && campaign_order.date == now" class="row py-2 mb-10">
                        <div class="col text-center">
                          <img class="frascos_campania" src="@/assets/store/diloconnieve/frascos.svg" alt="">
                        </div>
                      </div>

                      <ItemCartMobile
                        v-for="item in cart.cart_products" :key="item.id"
                        :item="item"
                        color_text="color-white"
                        color_badge="blank"
                        :dark="false"
                        color_remove="white"
                      />
                    </div>

                    <div v-if="!cart.cart_products.length">
                      <p class="text-center m-0 pb-5 h3 color-white font-general-r">Tu carrito esta vacio.</p>
                    </div>
                    <div class="d-flex justify-content-center">
                      <div class="border-white mb-10 mt-5 d-flex"></div>
                    </div>

                    <div v-if="cart.cart_products.length" class="d-flex justify-space-between h6 color-white font-general-l font-weight-bold ">
                      <p>SUBTOTAL</p>
                      <p>{{ currencyFormat(cart_total) }}</p>
                    </div>
                    <div v-if="select_discount" class="d-flex justify-space-between h6 color-white font-general-l font-weight-bold ">
                      <p>{{ select_discount.code }}</p>
                      <p>{{ select_discount && select_discount.type != 'shipping_free' ? currencyFormat(amount_discount) : 'ENVÍO GRATIS' }}</p>
                    </div>
                    <div v-if="cart.cart_products.length" class="h6 d-flex justify-space-between color-white font-general-r font-weight-bold">
                      <p>ENVÍOS</p>
                      <p>{{ delivery_type ? delivery_type == 'free' ? 'PICKUP' : 'DELIVERY' : '' }}</p>
                      <p>{{ currencyFormat(delivery_price_global) }}</p>
                    </div>
                    <div v-if="cart.cart_products.length" class="d-flex justify-space-between h6 color-white font-general-l font-weight-bold ">
                      <p>TOTAL</p>
                      <p>{{ currencyFormat(total_cart + delivery_price_global) }}</p>
                    </div>
                  </v-card-text>
                </v-card>

              </v-sheet>
            </v-bottom-sheet>
          </div>

          <div class="swipe-text d-flex align-items-center">
            {{ currencyFormat(total_cart + delivery_price_global) }}
          </div>

          <div @click="goCart()" class="swipe-text text-right mr-3">
            {{ !['BuyPayment', 'SubscriptionPayment'].includes($route.name) ? 'FINALIZAR' : 'VOLVER' }}
          </div>
        </div>

        <div v-if="!sheet" class="d-flex align-items-center" style="position: relative;">
          <v-badge
            left
            :content="`${cart.cart_products.length}`"
            color="accent"
            offset-x="10"
            offset-y="10"
            class="badge-bolsa-swipe"
          >
            <img
              @click="sheet = true"
              class="cart-image-bolsa"
              src="@/assets/store/iconos/bolsa.svg"
            >
          </v-badge>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
// import HomeService from '@/services/home.service'
import { currencyFormat } from '@/helpers'
import ItemCartMobile from '@/components/store/mobile/ItemCartMobile'
import moment from 'moment'

export default {
  name: 'SwipeUpCart',
  components: {
    ItemCartMobile
  },
  data:() => ({
    now: moment().format('YYYY-MM-DD'),
    sheet: false,
    added_cart: false,
    loading_btn_remove_cart: false,
    loading_btn_clean_cart: false
   }),
  watch: {
    sheet(newval) {
      if (newval) {
        document.getElementById('swipe-up').style.zIndex  = '3000';
      } else {
        document.getElementById('swipe-up').style.zIndex  = '1000';
      }
    }
  },
  computed: {
    ...mapState(['campaign_order', 'cart', 'is_auth', 'user', 'delivery_price_global', 'delivery_type', 'cart_total', 'select_discount', 'amount_discount']),
    ...mapGetters(['total_cart'])
  },
  methods: {
    removeItemCart(item_id) {
			try {
        this.loading_btn_remove_cart = true
        setTimeout(() => {
          this.$store.dispatch('removeItemCart', { id: item_id })
          this.loading_btn_remove_cart = false
        }, 500)
			} catch (error) {
				this.$notify({
					group: 'admin',
					title: 'Ocurrio un problema: '.error.message,
					type: 'success',
				})
			}
    },
    goCart() {
      if (this.cart.cart_products.length) {
        if (this.$route.name != 'Checkout') {
          this.$router.push('/checkout')
        } else {
          if (this.$route.name == 'BuyPayment') {
            this.$router.push('/checkout')
          } else {
            this.$router.push('/procesar-pago')
          }
        }
      }
    },
    checkout() {
      this.$emit('closeModal')
      this.$router.push('/procesar-pago')
    },
    currencyFormat(price) {
			return currencyFormat(price)
		}
  }
}
</script>

<style >
.bottom-sheet {
  z-index: 210;
}
.swipe-text {
  font-size: 18px
}
.v-card__text {
  overflow: auto;
}
.margin {
  margin-bottom: 200px;
}
.bolsa-container {
  position: relative;
}
.bolsa-single-container {
  position: relative;
  right: -110px;
  top: -60px;
}
@media (max-width: 425px) {
  .bolsa-container {
    top: -50px;
    left: -20px;
  }
}
</style>
